<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <h3 class="col mb-0">{{ $t('importtask.detail_title') }}</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="row" v-if="data">
          <div class="col-2"> {{ $t('status') }} </div>
          <div class="col">
            {{ data.ProcessState_Enum }}
          </div>
      </div>
      <div class="row" v-if="isProcessed">
        <div class="col-2"> {{ $t('result') }} </div>
        <div class="col">
          <span style="color: #fff;" :style="processResultStyle">
            {{ data.ProcessResult_Enum }}
          </span>
        </div>
      </div>
      <div v-if="data && data.ErrorMessage" class="row mt-2">
        <div class="col-2" style="font-weight: bold;">
          {{ $t('importtask.error_msg') }}
        </div>
        <div class="col">
          {{ data.ErrorMessage }}
        </div>
      </div>

      <div class="row" v-if="data">
        <div class="col-12 my-3">
          {{ statusMessage }}
        </div>
      </div>

      <import-detail v-if="isProcessed || isCancelled" :data="data"/>
      <import-progress v-if="isRunning" :progress="progress"/>
      <div class="row">
        <div class="col"><hr></div>
      </div>

      <div class="row">
          <div class="col text-right">
            <loading-button :title="$t('close')" @click="$emit('close')" />
          </div>
        </div>
    </div>
  </div>
</template>
<script>
import { EventStreamNotificationListener } from 'libs/notificationlistener';

import ImportController from '@/controller/importcontroller.js';
import ImportDetail from './components/ProcessedImportDetail.vue';
import ImportProgress from './components/ImportProgress.vue';
const controller = new ImportController();

export default {
  props: {
    importId: {}
  },
  components: {
    'import-detail': ImportDetail,
    'import-progress': ImportProgress
  },
  data () {
    return {
      progress: null,
      listener: new EventStreamNotificationListener(`/mvc/importprogresseventstream/message?importtaskid=${this.importId}`),
      data: null
    };
  },
  async mounted () {
    if(this.importId){
      await this.loadData();
      this.listener.Bus.$on('import-progress', this.processNotificationEvent);
    }
  },
  beforeDestroy() {
    this.listener.close();
  },
  methods: {
    async processNotificationEvent(progress) {
      if(this.progress == null){
        if(this.data){
          this.data.ProcessState = 1;
          this.data.ProcessState_Enum = this.$t('importtask.running');
          this.$emit('started-import');
        }
      }
      this.progress = progress;

      if(progress.Finished)
      {
        this.listener.close();
        await this.loadData();
        this.$emit('completed');
      }
    },
    async loadData(){
      let result = await controller.GetItem(this.importId);
      this.data = result;
    }
  },
  computed: {
    isProcessed(){
      return this.data && this.data.ProcessState === 2;
    },
    isCancelled(){
      return this.data && this.data.ProcessState === 3;
    },
    isRunning(){
      return this.data && this.data.ProcessState === 1;
    },
    statusMessage(){
      if(this.data){
        if(this.data.ProcessState === 0){
          return this.$t('importtask.statusses.pending');
        }
        if(this.data.ProcessState === 1){
          return this.$t('importtask.statusses.running');
        }
        if(this.data.ProcessState === 2){
          return this.$t('importtask.statusses.processed');
        }
        
      }
    },
    processResultStyle(){
      if(this.data){
        if(this.data.ProcessResult === 1) return { 'color': 'green' };
        else return { 'color': 'red' };
      }
    }
  }
};
</script>